module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.19c1d9b.eot";